import BreadcrumbHiddenContent from './BreadcrumbHiddenContent';

export default BreadcrumbHiddenContent;
